import { useEffect } from "react";

/**
 * Charge Tawk.to uniquement APRÈS que l'utilisateur ait accepté les cookies fonctionnels/marketing.
 * Écoute les changements de consentement via l'événement personnalisé "mss-consent-updated".
 */
export default function TawkChat() {
  useEffect(() => {
    const loadTawk = () => {
      if (window.Tawk_API || document.getElementById("tawk-script")) return;
      const prefs = JSON.parse(localStorage.getItem("mss_cookie_prefs") || "null");
      // On charge Tawk si l'utilisateur a donné son consentement (marketing OU functional)
      if (!prefs || (!prefs.marketing && !prefs.analytics)) return;

      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();
      const s = document.createElement("script");
      s.id = "tawk-script";
      s.async = true;
      s.src = "https://embed.tawk.to/693ae25c5ec451197a90d8df/1jc708ekb";
      s.charset = "UTF-8";
      s.setAttribute("crossorigin", "*");
      const first = document.getElementsByTagName("script")[0];
      first.parentNode.insertBefore(s, first);
    };

    loadTawk();
    window.addEventListener("mss-consent-updated", loadTawk);
    return () => window.removeEventListener("mss-consent-updated", loadTawk);
  }, []);

  return null;
}
